import React, { useState } from "react";
import edit_pencil_icon from "../../assets//icons/edit_pencil_icon.png";

const CancellingTaskModal = ({ setCancelTask, setCancelCompleted }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const handleCancelling = () => {
    setCancelTask(false);
    setCancelCompleted(true);
  };
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex flex-col ">
          <div className="flex justify-center">
            <div className="text-[20px] font-bold">Cancelling task</div>
          </div>

          <div className="flex justify-between mt-4">
            <div className="text-[12px]">
              Current Task: <span className="font-bold">Follow Up (Call)</span>
            </div>
            <div className="cursor-pointer">
              <img src={edit_pencil_icon} alt="edit"/>
            </div>
          </div>

          <div className="mt-4">
            <p className="text-[12px] text-[#828282]">Reschedule task date</p>
            <input
              type="text"
              placeholder="Enter the date here"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>

          <div className="mt-4">
            <p className="text-[12px] text-[#828282]">Add Comments/Notes</p>
            <input
              type="text"
              placeholder="Enter the comment"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>

          <div className="text-[#828282] text-[14px] mt-6">Transfer to</div>
          <div>
            <select
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              className="border border-[#2F80ED] p-2 w-full rounded-lg text-[14px]"
            >
              <option value="" disabled hidden>
                Search & select the person
              </option>
              <option value="person1" className="text-[12px]">
                Amit Gupta
              </option>
              <option value="person2" className="text-[12px]">
                Rohit Mehta
              </option>
            </select>
          </div>

          <div className="flex justify-between my-5">
            <button
              className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
              onClick={() => setCancelTask(false)}
            >
              Discard
            </button>
            <button
              className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
              onClick={handleCancelling}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancellingTaskModal;
